
import { memo } from "react";
import { WeightInput } from "./personal-plan/weight-selector/WeightInput";
import { WeightControls } from "./personal-plan/weight-selector/WeightControls";
import { WeightStatusIndicators } from "./personal-plan/weight-selector/WeightStatusIndicators";
import { WeightUnitDisplay } from "./personal-plan/weight-selector/WeightUnitDisplay";
import { useWeightSelectorLogic } from "./personal-plan/weight-selector/hooks/useWeightSelectorLogic";

interface OptimizedWeightSelectorProps {
  value: number;
  onChange: (value: string) => void;
  className?: string;
  disabled?: boolean;
  exerciseId?: string;
  setIndex?: number;
  isPersonalPlan?: boolean;
}

export const OptimizedWeightSelector = memo(function OptimizedWeightSelector({ 
  value, 
  onChange, 
  className,
  disabled = false,
  exerciseId = "",
  setIndex = 0,
  isPersonalPlan = false
}: OptimizedWeightSelectorProps) {
  const {
    localValue,
    isFocused,
    isSyncing,
    hasUnsavedChanges,
    lastSyncTime,
    inputRef,
    handleInputChange,
    handleInputBlur,
    handleInputFocus,
    handleKeyDown,
    increment,
    decrement
  } = useWeightSelectorLogic({
    value,
    onChange,
    disabled,
    exerciseId,
    setIndex,
    isPersonalPlan
  });

  return (
    <div className={`flex items-center ${className}`}>
      <div className="relative flex-1">
        <WeightInput
          ref={inputRef}
          value={localValue}
          onChange={handleInputChange}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          hasUnsavedChanges={hasUnsavedChanges}
          isSyncing={isSyncing}
          lastSyncTime={lastSyncTime}
        />
        
        <WeightControls
          onIncrement={increment}
          onDecrement={decrement}
          disabled={isFocused || disabled}
        />
        
        <WeightStatusIndicators
          isSyncing={isSyncing}
          lastSyncTime={lastSyncTime}
        />
      </div>
      
      <WeightUnitDisplay
        lastSyncTime={lastSyncTime}
        isSyncing={isSyncing}
      />
    </div>
  );
});
